import styled from 'styled-components';
import { ColorAddiBackgroundWhite } from '@addi/foundation/dist/web/colors';
import { Icons, Paragraph } from '../';
export const SectionContainer = styled.div `
  padding: 1rem 0.5rem;
`;
export const SectionHeaderContainer = styled.div `
  display: flex;
  flex-direction: row;
  background-color: ${ColorAddiBackgroundWhite};
  justify-content: space-between;
  align-items: center;
`;
export const SectionHeaderAction = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  height: 100%;
`;
export const SectionHeaderTitle = styled(Paragraph) `
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 16px;
  height: 100%;
`;
export const SectionInfoContainer = styled.div `
  display: flex;
  flex-direction: row;
  background-color: ${ColorAddiBackgroundWhite};
`;
export const SectionInfoPicture = styled.div `
  display: flex;
  height: 100%;
  width: 64px;
  align-items: center;
  justify-content: center;
`;
export const SectionInfoContent = styled.div `
  flex: 1;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
export const SectionInfoCollapseAction = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  height: 100%;
`;
export const DetailsAction = styled.div `
  cursor: pointer;
`;
export const DetailsActionIcon = styled(Icons) `
  font-size: 24px;
`;
export const PictureIcon = styled(Icons) `
  font-size: 18px;
`;
//# sourceMappingURL=checkout-section.styled.js.map